import Navigation from "../Navigation";
import { IAboutusViewProps } from "./Aboutus.interfaces";
import BookDemo from "../BookDemo";
// import UserLoginBox from "../UserLoginBox";
export default function AboutusView(props: IAboutusViewProps) {

    const TeamMemberCard = ({ name, title, imageUrl, isHovered, linkedinUrl }: { name: string; title: string; imageUrl: string; isHovered: boolean; linkedinUrl: string ; }) => {
  return (
    <div className={`relative shadow-md rounded-lg overflow-hidden group transition-all duration-300 ease-in-out group hover:transform hover:scale-105 hover:shadow-2xl ${isHovered ? '' : 'shadow-lg'}`}>
      {/* <div className="bg-black h-full invert"></div> */}
      <img src={imageUrl} alt={name} className="w-full h-auto object-cover grayscale group-hover:grayscale-0 duration-300 ease-in-out" />
      <div className={`absolute m-2 bottom-0 left-0 right-0 p-4  bg-white bg-opacity-90 backdrop-blur-sm transition-all duration-300 ease-in-out ${isHovered ? 'rounded-lg' : ''}`}>
        <div className="flex items-center justify-between">
          <div className="text-left">
            <h3 className="text-sm font-bold text-pink-500">{name}</h3>
            <p className="text-xs text-gray-600">{title}</p>
          </div>
          <a href={linkedinUrl} target="_blank" className="text-pink-500 hover:text-pink-600 transition-colors duration-300">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

  const teamMembers = [
    { name: 'Ajay Setia', title: 'Founder and CEO', imageUrl: './images/aboutus/ajay.webp',linkedinUrl:"https://www.linkedin.com/in/ajaysetia/", isHovered: true },
    { name: 'Sagar Setia', title: 'Co-Founder- Director India Operations', imageUrl: './images/aboutus/sagar.webp',linkedinUrl:"https://www.linkedin.com/in/sagarsetia/", isHovered: true },
    { name: 'Ali Akoddos', title: 'Operations Director, UK ', imageUrl: './images/aboutus/ali.webp',linkedinUrl:"https://www.linkedin.com/in/ali-akoddos-90236723/", isHovered: true },
    { name: 'Nazir Jinnah', title: 'Director of International Operations, Africa', imageUrl: './images/aboutus/nazirjinnah.webp',linkedinUrl:"", isHovered: true },
    { name: 'Ashok Taravath', title: 'Business Head - India', imageUrl: './images/aboutus/ashok.webp',linkedinUrl:"https://www.linkedin.com/in/ataravath/", isHovered: true },
  ];

//   console.log("Just for merge")

const flagshipProducts = [
    {
        img: "./images/vrworld/invinciblelogo.webp",
        imgAlt: "Invincible Ocean Logo",
        imgClass: "pb-5 max-md:pb-2 object-contain w-[150px]",
        title: "eKYC & Fraud Prevention Suite",
        desc: "A plug-and-play onboarding stack with 250+ verification APIs.",
    },
    {
        img: "./images/vrworld/cloudlogo.webp",
        imgAlt: "CloudTuner.ai Logo",
        imgClass: "pb-5 max-md:pb-2 object-contain w-[150px]",
        title: "CloudTuner.ai",
        desc: "AI-powered platform for cloud cost optimization, security monitoring, and performance improvement.",
    },
    {
        img: "./images/vrworld/motointel.webp",
        imgAlt: "MotoIntel.ai Logo",
        imgClass: "max-md:pb-2 object-contain w-[120px]",
        title: "MotoIntel.ai",
        desc: "Automotive data intelligence and analytics engine for OEMs, insurers, and fleet operators.",
    },
    {
        img: "./images/darklogo.webp",
        imgAlt: "Banking Metaverse Logo",
        imgClass: "pb-5 max-md:pb-2 object-contain w-[200px]",
        title: "Banking Metaverse",
        desc: "AI-enabled virtual banking experiences with real-time customer interaction.",
    },
];

const FlagshipProductCard = ({
    img,
    imgAlt,
    imgClass,
    title,
    desc,
}: {
    img: string;
    imgAlt: string;
    imgClass: string;
    title: string;
    desc: string;
}) => (
    <div className="flex-1 min-w-[250px] max-w-[350px] shadow-md rounded-lg py-5 px-4 bg-white hover:scale-110 max-md:hover:scale-100 duration-500 text-[#1C2347] mx-auto">
        <div className="flex w-full justify-center">
            <img src={img} className={imgClass} alt={imgAlt} />
        </div>
        <h5 className="font-[500] text-[30px] max-md:text-[20px] pb-7 pt-7 max-md:pt-5 max-md:pb-5">
            {title}
        </h5>
        <p className="font-[300] text-[16px] max-md:text-[14px]">{desc}</p>
    </div>
);

    return (
        <>
            {/* {props.showlogin === true && (
                <UserLoginBox
                    redirectionURL="/metaverse/65b741def8309762720ad53f"
                    // loginController={props.loginController}
                /> // Since the line 122, says Login to Eternity City, but can be changed later => TP | 2024-01-30 14:39:44
            )} */}
             {props.showDemo === true && (
                            <BookDemo demoController={props.demoController} />
                        )}
            <div className="font-['roboto']">
                <section className="">
                    <div
                        className="bg-cover"
                        style={{
                            backgroundImage: `url('./images/aboutus/background.webp')`,
                        }}
                        data-testid="element-with-background-image"
                    >
                        <div className="bg-black/[0.20]">
                            <Navigation />
                            <div className="max-w-screen-2xl mx-auto max-md:px-2 max-md:block text-center px-10 max-md:px-2 text-white">
                                <div></div>
                                <div className="py-48 max-md:py-24">
                                    <h3 className="my-5 text-5xl font-bold">
                                        About Us
                                    </h3>
                                    <p className="font-['roboto'] text-[18px] max-md:text-[14px] font-[500] max-md:pt-5 max-md:font-[400] max-w-screen-2xl mx-auto">
                                       Invincible Ocean is a Dubai-headquartered blockchain-first product development company specializing in AI-driven solutions, blockchain-powered platforms, and immersive metaverse experiences. We work with 5+ leading banks and 200+ enterprise clients, delivering future-ready solutions that transform industries such as fintech, banking, automotive, retail, and education.
                                    </p>
                                    <p className="mt-10 font-['roboto'] text-[18px] max-md:text-[14px] font-[500] max-md:pt-5 max-md:font-[400] max-w-screen-2xl mx-auto">At our core, we build scalable, secure, and intelligent platforms—backed by deep expertise in AI, decentralized systems, and virtual environments.</p>
                                    
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-[#F5FAFF]">
                        <div className="max-w-screen-2xl mx-auto max-md:px-2">
                            <h5 className="pt-14  max-md:pt-12 text-center leading-[36px] text-[48px] font-[600] text-[#1C2347]">
                                Flagship Products
                            </h5>
                              <hr className="w-32 h-1 mx-auto mt-4 bg-blue-500 border-0 rounded" />
                            <div className="flex flex-wrap gap-4 py-10 max-md:py-5 px-2 ">
                                {flagshipProducts.map((product, idx) => (
                                    <FlagshipProductCard key={idx} {...product} />
                                ))}
                            </div>
                        </div>
                    </div>
                    
                    <div className="max-w-screen-2xl mx-auto max-md:px-2  my-20 max-md:my-7">
                        <div className="text-center pb-20">
                                    <h2 className="text-3xl  font-bold text-[#1C2347] sm:text-4xl xl:text-5xl">
                                       Core Capabilities
                                    </h2>
                                    <hr className="w-32 h-1 mx-auto mt-4 bg-blue-500 border-0 rounded" />
                        </div>            
                        <div className="grid grid-cols-3 max-md:grid-cols-1">
                        <div className="px-7 text-left">
                            <h5 className="text-[#1C2347] text-xl">
                               Blockchain First – End-to-End Product Lifecycle Management

                            </h5>
                            <div className="border-b-2 border-b-[#136CC5] w-7 mb-2"></div>
                            <p className="max-md:mb-4 text-[#777777] text-[18px] font-[400] font-['roboto']">
                                We deliver complete blockchain ecosystems—from consulting to development and deployment—with smart contract support in Solidity, Rust, and Move for Ethereum, Solana, Aptos, and other ecosystems.
                            </p>
                        </div>
                        <div className="px-7 text-left">
                            <h5 className="text-[#1C2347] text-xl">
                                AI Expertise

                            </h5>
                            <div className="border-b-2 border-b-[#136CC5] w-7 mb-2"></div>
                            <p className="max-md:mb-4 text-[#777777] text-[18px] font-[400] font-['roboto']">
                                Predictive analytics, intelligent automation, fraud detection, and AI tokenization—integrated across all platforms to enable smart decision-making and personalized customer journeys.
                            </p>
                        </div>
                        <div className="px-7 text-left">
                            <h5 className="text-[#1C2347] text-xl">Metaverse Innovation</h5>
                            <div className="border-b-2 border-b-[#136CC5] w-7 mb-2"></div>
                            <p className="max-md:mb-4 text-[#777777] text-[18px] font-[400] font-['roboto']">
                                We build immersive 3D environments for banking, retail, and education—enabling lifelike virtual interactions and gamified engagement using blockchain-powered identity and assets.
                            </p>
                        </div>
                        </div>
                    </div>
                        <div className="py-12 bg-white sm:py-16 lg:py-20">
                            <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                                <div className="text-center">
                                    <h2 className="text-3xl  font-bold text-[#1C2347] sm:text-4xl xl:text-5xl">
                                        Meet our team
                                    </h2>
                                    <hr className="w-32 h-1 mx-auto mt-4 bg-blue-500 border-0 rounded" />
                                </div>

                                <div className="grid grid-cols-1 gap-8 mt-12 sm:grid-cols-2 lg:grid-cols-3">
                                {teamMembers.map((member, index) => (
                                    <TeamMemberCard
                                    key={index}
                                    name={member.name}
                                    title={member.title}
                                    imageUrl={member.imageUrl}
                                    isHovered={member.isHovered}
                                    linkedinUrl={member.linkedinUrl}
                                    />
                                ))}
                                </div>
                            </div>
                        </div>
                    <div className="py-20 px-10 text-center bg-[#F1F1F1]">
                        <div className="max-w-screen-2xl mx-auto max-md:px-2">
                            <h5 className="pb-8 text-[48px] text-[#1C2347] font-[700]">
                                Our Mission
                            </h5>
                            <p className="font-['roboto'] font-semibold text-[18px] text-[#777777]">
                                Our mission is simple yet profound: To empower
                                individuals and businesses with the tools to
                                transcend reality. We believe in the
                                transformative power of AR and VR to
                                revolutionize industries, enhance education,
                                elevate entertainment, and unlock new ways of
                                experiencing the world around us.
                            </p>
                        </div>
                    </div>

                    <div className="bg-gradient-to-b from-[#2059C5] to-black text-white">
                        <div className="text-center py-24 max-w-screen-2xl mx-auto max-md:px-2">
                            <h5 className="text-3xl mb-7 max-md:mb-5">
                                {" "}
                                Join Us on Our Journey{" "}
                            </h5>
                            <p className="mb-10 px-2 font-['roboto'] text-[18px]">
                                {" "}
                                Whether you're an individual seeking new
                                dimensions of entertainment or a business aiming
                                to revolutionize your industry, Invincible ocean
                                invites you to join us on this exciting journey.
                                Together, we'll explore the limitless
                                possibilities of augmented and virtual reality.
                            </p>
                            {/* <button
                                onClick={props.loginController}
                                className="border-2 bg-[#FFF8F840] text-white max-md:mt-2 transition duration-300 ease-in-out hover:scale-[1.05] hover:bg-[#FFF8F860] px-8 py-3 rounded-md"
                            >
                                Login to Eternity City
                                <i className="fa fa-long-arrow-right ml-4"></i>
                            </button> */}
                            <div className="py-5">
                                    <button
                                        className="bg-blue-100 px-10 py-3 hover:scale-[1.1] hover:bg-gradient-to-l transition duration-300 ease-in-out rounded-md mr-4 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold"
                                        onClick={props.demoController}
                                    >
                                        Ask an Expert
                                    </button>
                                </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
